import(/* webpackMode: "eager", webpackExports: ["YayasanProvinsi"] */ "/builds/wartek-id/data-pipeline/data-portal-ui/modules/DataInduk/yayasan/YayasanProvinsi.tsx");
